/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'click', '.btn--elise', function( e ) {
        e.preventDefault();
        console.log( 'Opening Elise AI...' );
        eliseAi.hc.openScheduling();
      } );

      $( '.slide-data-target' ).on( 'toggleAfter', function( event ) {
        if ( event.target.hasAttribute( 'data-toggle-target-next' ) ) {
          $( event.target ).next().slideToggle();
        } else {
          $( event.target.getAttribute( 'data-toggle-target' ) ).slideToggle();
        }
      } );

      $( '.fade-data-target' ).on( 'toggleAfter', function( event ) {
        if ( event.target.hasAttribute( 'data-toggle-target-next' ) ) {
          $( event.target ).next().fadeToggle( 250 );
        } else {
          $( event.target.getAttribute( 'data-toggle-target' ) ).fadeToggle( 250 );
        }
      } );

      /* Multipage Form */
      const continueButton = document.querySelector( '.multi-page-form__btn' );
      const startSection = document.querySelector( '.multi-page-form__start' );
      const formPage = document.querySelector( '.multi-page-form__page' );

      if ( !continueButton || !startSection || !formPage ) return;

      formPage.setAttribute( 'aria-hidden', 'true' );

      document.body.classList.add( 'mpf-no-scroll' );

      continueButton.addEventListener( 'click', ( e ) => {
        e.preventDefault();

        startSection.classList.add( 'is-active' );
        formPage.classList.add( 'is-active' );

        document.body.classList.remove( 'mpf-no-scroll' );

        formPage.removeAttribute( 'aria-hidden' );

        const firstInput = formPage.querySelector( 'input, select, textarea, button' );
        if ( firstInput ) firstInput.focus();

        formPage.scrollIntoView( {behavior: 'smooth'} );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.navbar .alert-banner' ).length && !localStorage.getItem( 'x4k8m3n7_alert_banner_dismissed' ) ) {
        $( '.alert-banner' ).show();
        const root = document.querySelector( ':root' );
        const navbarHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const alertBannerHeight = parseInt( $( '.navbar .alert-banner' ).outerHeight() );

        const newNavbarHeight = ( navbarHeight + alertBannerHeight ) + 'px';
        const newTopOffset = topOffset.slice( 0, -1 ) + ' + ' + alertBannerHeight + 'px)';

        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        root.style.setProperty( '--alertBannerHeight', alertBannerHeight + 'px' );
      }

      $( '.alert-banner .close-alert' ).on( 'click', function() {
        const root = document.querySelector( ':root' );
        const navbarHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const alertBannerHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--alertBannerHeight' );

        const newNavbarHeight = ( parseInt( navbarHeight ) - parseInt( alertBannerHeight ) ) + 'px';
        const newTopOffset = topOffset.replace( ' + ' + parseInt( alertBannerHeight ) + 'px', '' );

        $( '.alert-banner' ).remove();
        root.style.setProperty( '--alertBannerHeight', '0px' );
        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        localStorage.setItem( 'x4k8m3n7_alert_banner_dismissed', true );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
